import { useCallback, useState } from 'react';

/**
 * HTML5 drag-and-drop reorder helper for form field lists.
 * Mirrors legacy CreateEditLeadForm card reorder behavior.
 */
export default function useFieldDragReorder(onReorder) {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = useCallback((event, index) => {
    event?.dataTransfer?.setData('text/plain', String(index));
    if (event?.dataTransfer) event.dataTransfer.effectAllowed = 'move';
    setDraggedIndex(index);
  }, []);

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
  }, []);

  const handleDrop = useCallback(
    (index) => {
      if (draggedIndex == null || draggedIndex === index) {
        setDraggedIndex(null);
        return;
      }
      onReorder(draggedIndex, index);
      setDraggedIndex(null);
    },
    [draggedIndex, onReorder]
  );

  const handleDragEnd = useCallback(() => {
    setDraggedIndex(null);
  }, []);

  return {
    draggedIndex,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
  };
}
